<template>
  <div class="confirm-duplicate-keywords">
    <closer @click="close" />
    <div class="header">
      <h4>{{ $t('duplicate-confirm', { count: totalKeywords }) }}</h4>
    </div>
    <div class="footer">
      <kw-button :button-text="$t('cancel')" button-type="text" @click="close" />
      <kw-button :button-text="$t('confirm')" button-type="primary" @click="confirmDuplicate" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmDuplicateKeywords',
  props: {
    totalKeywords: {
      type: Number,
      required: true,
    },
    handler: {
      type: Function,
      required: true,
    },
  },
  methods: {
    confirmDuplicate() {
      this.close();
      this.handler();
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
@import '~sass/modal';

.confirm-duplicate-keywords {
  height: 100%;
  padding: 16px;

  button {
    &.button-closer {
      position: absolute;
      top: 14px;
      right: 14px;

      .icon-cross-round {
        font-size: 16px !important;
        margin-right: 0;
      }
    }
  }

  .header {
    h4 {
      margin: 0;
      font-size: 17px;
    }
  }

  .footer {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    font-weight: 500;

    button {
      font-size: 14px;
      margin: 0 12px;
    }
  }
}
</style>
